import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import './ErrorLog.scss';
export const ErrorLog = ({ errorLog, setErrorLog, }) => {
    if (errorLog.length === 0) {
        return;
    }
    const clearMessage = (index) => {
        setErrorLog(errorLog.filter((_, i) => i !== index));
    };
    return (_jsxs("div", { className: "error-log", children: [_jsx("h3", { children: "Errors and messages" }), _jsx("div", { children: errorLog.map((message, i) => _jsxs("div", { children: [_jsx("div", { children: message }), _jsx("button", { onClick: () => { clearMessage(i); }, children: "OK" })] }, message)) })] }));
};
